export const BookingPath: string = '/:slug';
export const IntakeFormPath: string = '/:slug/intake-form';
